import axios from 'axios';
import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import { push } from 'react-router-redux';

import { setRXDimension } from '../../gtmMetrics';

import {
  SET_RX,
  ERROR_SET_RX,
  SET_JWT,
  RX_NOT_FOUND_TEMPLATE,
  INVALID_RX_TEMPLATE,
  INVALID_RX_RR_PHONE,
  INVALID_RX_VPA_PHONE,
  INVALID_RX_VFC_PHONE,
  PRACTICE_TYPE_FLAG_RR,
  PRACTICE_PLATFORM_TYPE_RR,
  PRACTICE_PLATFORM_TYPE_VPA,
} from './types';
import { removeDashesFromRxNumber } from '../../util';

export const setRx = (rx, rxNum) => ({
  type: SET_RX,
  payload: rx,
  rxNum,
});

export const onErrorsetRx = (dispatch, path) => {
  dispatch({ type: ERROR_SET_RX });
  dispatch(push(path));
};

export const setJWT = jwt => ({
  type: SET_JWT,
  payload: jwt,
});

const isValidRx = rx => {
  if (typeof rx === 'undefined' || _.isEmpty(rx)) {
    return false;
  }
  return (
    _.isEqual('CLIENT_CREDIT_CARD', rx.billingType) &&
    _.isEqual('CLIENT', rx.shipToType)
  );
};

const isVprOrRrScript = rx => {
  let returnValue = false;
  const rxPlatform = rx.customer.practicePlatformTypeId;
  if (
    rxPlatform === PRACTICE_PLATFORM_TYPE_VPA ||
    rxPlatform === PRACTICE_PLATFORM_TYPE_RR
  ) {
    returnValue = true;
  }
  return returnValue;
};

const getSubmissionErrors = rx => {
  let globalMessage; /* [apk] todo: these should have a more flag-y name */
  let rxNumberMessage;
  let lastNameMessage;
  if (typeof rx !== 'undefined' && !_.isEmpty(rx)) {
    if (
      !_.isEqual('CLIENT_CREDIT_CARD', rx.billingType) ||
      !_.isEqual('CLIENT', rx.shipToType)
    ) {
      if (
        !_.isEmpty(rx.customer) &&
        !_.isEmpty(rx.product) &&
        !_.isEmpty(rx.product.productCompoundAttributeSubsidiaryBrand) &&
        _.isEqual(
          PRACTICE_TYPE_FLAG_RR,
          rx.product.productCompoundAttributeSubsidiaryBrand
        )
      ) {
        globalMessage = INVALID_RX_TEMPLATE(INVALID_RX_RR_PHONE);
      } else {
        globalMessage = INVALID_RX_TEMPLATE(INVALID_RX_VPA_PHONE);
      }
      rxNumberMessage = true;
      lastNameMessage = true;
    }
  } else if (rx === 404 || rx === 424) {
    globalMessage = RX_NOT_FOUND_TEMPLATE;
  } else if (rx === 403) {
    globalMessage = INVALID_RX_TEMPLATE(INVALID_RX_VFC_PHONE);
  }
  return {
    _error: globalMessage || false,
    lastName: lastNameMessage || false,
    rxNumber: rxNumberMessage || false,
  };
};

const getRx = () => (dispatch, getState) => {
  const state = getState();
  let rxNumber;
  let lastName;
  if (
    Object.keys(state.form).length === 0 &&
    state.form.constructor === Object
  ) {
    rxNumber = state.lookup.RxLookupForm.rxNumber; // eslint-disable-line prefer-destructuring
    lastName = state.lookup.RxLookupForm.lastName; // eslint-disable-line prefer-destructuring
  } else {
    rxNumber = state.form.RxLookupForm.values.rxNumber; // eslint-disable-line prefer-destructuring
    lastName = state.form.RxLookupForm.values.lastName; // eslint-disable-line prefer-destructuring
  }

  const rxNum = removeDashesFromRxNumber(rxNumber);
  setRXDimension(rxNum);
  lastName = encodeURIComponent(lastName || '').trim();
  const apiRequest = `${APIENDPOINT}/rx?rx-number=${rxNum}&lastname=${
    lastName
  }`;
  return (
    axios
      .get(apiRequest)
      /* We throw on-page errors on !isValidRx and 404s  */
      .then(response => {
        dispatch(setJWT(response.headers.authorization));
        if (isValidRx(response.data)) {
          // Return only scripts with practicePlatformType of 5 (VPA) or 6 (RR)
          if (!isVprOrRrScript(response.data)) {
            throw new SubmissionError(getSubmissionErrors(424));
          } else {
            dispatch(setRx(response.data), rxNum);
            dispatch(push('/cart'));
          }
        } else {
          throw new SubmissionError(getSubmissionErrors(response.data));
        }
      })
      .catch(error => {
        if (!_.isEmpty(error.response)) {
          const err = (error.response && error.response.status) || '500';
          if (err === 404) {
            throw new SubmissionError(getSubmissionErrors(err));
          } else {
            const path = `/${err}`;
            onErrorsetRx(dispatch, path);
          }
        } else if (error instanceof SubmissionError) {
          throw new SubmissionError(error.errors);
        } else {
          throw new SubmissionError(getSubmissionErrors(403));
        }
      })
  );
};
export default getRx;



// WEBPACK FOOTER //
// ./src/actions/userInformation/setRx.js